<template>
      <card>
        <list
                 v-if="$store.state.user.is_root"
              :columns="columns"
              :modalCreate="modalCreate"
              :removeLink="removeLink"
              :cardLink="cardLink"
              :isUpdate="true"
              :isAdd="true"
              :itemLink="itemLink"
              :setLink="setLink"
              :openItem="true"
              :fields="fields"
              :searchDisable="true"
              @change="change"
              @changeFunction="changeFunction"
              v-model="val"
        />
      </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      val: [],
      modalCreate: "schedule",
        fields: [
    {
          key: "position",
          label: "Номер урока",
          type: "field",
          textType: "text",
        },
        {
          col:'col-12 col-md-6',
          key: "from_at",
          label: "Начало урока",
          type: "mask",
          mask: "##:##",
          placeholder:'--:--'
        },
        {
          col:'col-12 col-md-6',
          key: "till_at",
          label: "Окончание урока",
          type: "mask",
          mask: "##:##",
          placeholder:'--:--'
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_schedule",
      itemLink: "schedules",
      setLink: "schedules",
      columns: [
     {
          key: "position",
          title: "Номер урока",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "from_at",
          title: "С",
  
          // disableLink: true,
        },
        {
          key: "till_at",
          title: "По",
     
          // disableLink: true,
        },
     
 
        {
          detail: true,
          remove: false,
        },
      ],
    };
  },
};
</script>
<style>
</style>
